import PropTypes from 'prop-types';
import './Pager.css';

// Pager (clone of the prototype's Pager): the "from–to de total" count
// strip on the LEFT, and a right-hand group holding the rows-per-page select +
// the numbered page buttons (‹ 1 2 3 …, with … elision past 7 pages, › ). The
// control group is ALWAYS shown — a single page renders "‹ 1 ›" with both arrows
// disabled, exactly as designed. Server-driven: it reports page intent via
// onPage / onPageSize and holds no data. Styles: Pager.css.
function pageNumbers(page, pageCount) {
  if (pageCount <= 7) {
    return Array.from({ length: pageCount }, (_, i) => i + 1);
  }
  const nums = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(pageCount - 1, page + 1);
  if (start > 2) nums.push('…');
  for (let i = start; i <= end; i++) nums.push(i);
  if (end < pageCount - 1) nums.push('…');
  nums.push(pageCount);
  return nums;
}

export default function Pager({
  page,
  pageCount,
  total,
  pageSize,
  onPage,
  onPageSize,
  sizes = [10, 25, 50, 100],
  unit = 'resultados',
}) {
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const nums = pageNumbers(page, pageCount);

  return (
    <div className="pager">
      <span className="pager__info">
        {from}–{to} de {total} {unit}
      </span>
      <div className="pager__right">
        {onPageSize && (
          <label className="pager__size">
            <span className="pager__size-lbl">Filas</span>
            <select
              value={pageSize}
              onChange={(e) => onPageSize(Number(e.target.value))}
            >
              {sizes.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        )}
        <div className="pager__ctrl">
          <button
            type="button"
            className="pager__btn"
            disabled={page === 1}
            onClick={() => onPage(page - 1)}
            aria-label="Anterior"
          >
            ‹
          </button>
          {nums.map((n, i) =>
            n === '…' ? (
              <span key={`dots-${i}`} className="pager__dots">
                …
              </span>
            ) : (
              <button
                type="button"
                key={n}
                className={`pager__btn${n === page ? ' is-on' : ''}`}
                onClick={() => onPage(n)}
              >
                {n}
              </button>
            ),
          )}
          <button
            type="button"
            className="pager__btn"
            disabled={page === pageCount}
            onClick={() => onPage(page + 1)}
            aria-label="Siguiente"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  );
}

Pager.propTypes = {
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPage: PropTypes.func.isRequired,
  onPageSize: PropTypes.func,
  sizes: PropTypes.arrayOf(PropTypes.number),
  unit: PropTypes.string,
};
